/**
 * it always returns true
 */
export const alwaysTrue = (): true => true;
